// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainExamsContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border: 1px solid #DCDFE1;
  border-radius: 0.5rem;
  box-shadow: none;
  margin-top: 1.5rem;
}

.examHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #DCDFE1;
}

.listContainer {
  width: 100%;
  scroll-behavior: smooth;
  overflow-x: auto;
  white-space: nowrap;
}

.listItem {
  padding: 0.5rem;
  width: 260px;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/pages/Cart/Exams/exams.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gCAAA;AACF;;AAGA;EACE,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;EACA,qBAAA;AAAF","sourcesContent":[".mainExamsContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  border: 1px solid #DCDFE1;\n  border-radius: 0.5rem;\n  box-shadow: none;\n  margin-top: 1.5rem;\n}\n\n.examHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border-bottom: 1px solid #DCDFE1;\n}\n\n\n.listContainer {\n  width: 100%;\n  scroll-behavior: smooth;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\n.listItem {\n  padding: 0.5rem;\n  width: 260px;\n  display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
